import { setC } from "@thi.ng/vectors/setc";
const mat33to44 = (out, m33) => setC(
  out || [],
  // x
  m33[0],
  m33[1],
  m33[2],
  0,
  // y
  m33[3],
  m33[4],
  m33[5],
  0,
  // z
  m33[6],
  m33[7],
  m33[8],
  0,
  // w
  0,
  0,
  0,
  1
);
export {
  mat33to44
};
